import { Component } from '@angular/core';
import { SharedService } from '../../shared';
import { PathologyDTO } from '../../model';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
	selector: 'ft-pathology-setting',
	templateUrl: './pathology-setting.component.html',
	styleUrls: ['./pathology-setting.component.scss'],
})
export class PathologySettingComponent {
	public pathologies: PathologyDTO[] = [];
	pathologyForm!: FormGroup;
	categories: string[] = [];
	categoryControl: FormControl = new FormControl<any>('');
	private currentCategory: string;

	constructor(
		private shared: SharedService,
		private sharedService: SharedService,
		private fb: FormBuilder
	) {
		this.pathologyForm = this.fb.group(new PathologyDTO());
		this.getPathologyCategories();
	}

	public getPathologies(category: string, clearArray: boolean = true) {
		if (clearArray) this.pathologies = [];
		this.sharedService
			.getPathologies(category)
			.subscribe(data => (this.pathologies = data));
	}

	private getPathologyCategories() {
		this.shared
			.getPathologyCategories()
			.subscribe(categories => (this.categories = categories));
	}

	onEnter(event: KeyboardEvent) {
		if (event.code === 'Enter') {
			const category = this.categoryControl.getRawValue();

			if (this.currentCategory) {
				this.shared
					.updatePathologyCategory(this.currentCategory, category)
					.subscribe(res => {
						if (res) {
							this.getPathologyCategories();
							this.currentCategory = null;
							this.categoryControl.patchValue('');
						}
					});
			} else {
				this.categories.push(category!);
				this.categoryControl.patchValue('');
			}
		}
	}

	onSavePathology(
		event: KeyboardEvent,
		pathology: PathologyDTO,
		category: string
	) {
		if (event.code === 'Enter') {
			pathology.category = category;

			this.shared.savePathology(pathology).subscribe(_ => {
				this.getPathologies(category, false);
				this.pathologyForm.patchValue(new PathologyDTO());
			});
		}
	}

	editPathology(pathology: PathologyDTO) {
		this.pathologyForm.patchValue(pathology);
	}

	editCategory(category: string) {
		this.currentCategory = category;
		this.categoryControl.patchValue(category);
	}
}
